import * as React from "react"

const H3 = ({ className, children }) => (
  <h3 className={`text-3xl lg:text-4xl font-heading ${className}`}>
    {children}
  </h3>
)

export default H3
